import VideoCaptionsPlaceholder from '@/shared/assets/images/video-captions-feature.jpg';
import { MixpanelEvents } from '@/shared/thirdParty/mixpanel';

import { LimitedFeatureContent, ModalContent } from '../types';
import { getBullets } from './bullets';
import { BULLETS_HEADER_TEXT, BUTTON_TEXTS } from './texts';

const BASE_CONTENT: ModalContent = {
  title: 'Unlock Captions feature',
  bulletsHeader: BULLETS_HEADER_TEXT.withCreatorPro,
  buttonText: BUTTON_TEXTS.toCreatorPro,
  features: getBullets([
    'translate100',
    'lipSync',
    'voiceCloneSettings',
    'voicePresets',
    'srtUploadDownload',
    'subtitles',
    'aiRewrite',
  ]),
  media: {
    src: VideoCaptionsPlaceholder,
    type: 'image',
  },
  mixpanelButtonClickEvent: MixpanelEvents.upgradeCaptionsModalClick,
  mixpanelOpeningEvent: MixpanelEvents.upgradeCaptionsModalShown,
  subtitle: 'Upgrade to Creator Pro to download videos with subtitles',
};

const TRIAL_PLAN_CONTENT = {
  ...BASE_CONTENT,
};

const STARTER_PLAN_CONTENT = {
  ...BASE_CONTENT,
  bulletsHeader: BULLETS_HEADER_TEXT.inTrial,
};

const CREATOR_PLAN_CONTENT = {
  ...BASE_CONTENT,
  bulletsHeader: BULLETS_HEADER_TEXT.inCreator,
};

export const VIDEO_SUBTITLES_CONTENT: LimitedFeatureContent = {
  creator: CREATOR_PLAN_CONTENT,
  starter: STARTER_PLAN_CONTENT,
  trial: TRIAL_PLAN_CONTENT,
};
